import { render, staticRenderFns } from "./accountActions.vue?vue&type=template&id=b4b6d876&"
import script from "./accountActions.vue?vue&type=script&lang=js&"
export * from "./accountActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports